export default () => {

    let scrollResources = document.querySelector('#resources');

    if(window.location.href.indexOf("#resources") > -1) {
        scrollResources.scrollIntoView({behavior: 'smooth'});
         
    }

};